<mat-card appearance="outlined">
  <mat-card-content>
    <button mat-raised-button color="primary" (click)="copyOrderDataToCSV()" type="submit" i18n="@@Copy Order Data To CSV">Copy Order Data To CSV</button>
    <button mat-raised-button color="primary" (click)="downloadOrderDataToCSV()" type="submit" i18n="@@Download Order Data To CSV">Download Order Data To CSV</button>
  </mat-card-content>
</mat-card>
